import React, { useMemo } from 'react';
import { Table as AntdTable, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import './styles.scss';

const STATUS_META = {
  NONE: { className: 'status-cell status-none', i18nKey: 'reportStatus.statusNone' },
  CREATED: { className: 'status-cell status-created', i18nKey: 'reportStatus.statusCreated' },
  APPROVED: { className: 'status-cell status-approved', i18nKey: 'reportStatus.statusApproved' },
  REJECTED: { className: 'status-cell status-rejected', i18nKey: 'reportStatus.statusRejected' },
};

const groupByOrganization = (rows) => {
  const map = new Map();
  rows.forEach((row) => {
    const orgId = row.organization && row.organization.id;
    if (!orgId) return;
    if (!map.has(orgId)) {
      map.set(orgId, {
        organizationId: orgId,
        organizationNameRu: row.organization.nameRu || '',
        organizationNameKk: row.organization.nameKk || '',
        statusByMonth: {},
      });
    }
    const monthId = row.month && row.month.id;
    if (monthId) {
      map.get(orgId).statusByMonth[monthId] = row.status;
    }
  });
  return Array.from(map.values());
};

export const Table = () => {
  const { t, i18n } = useTranslation();
  const tableData = useSelector((state) => state.reportStatus.tableData);
  const isLoading = useSelector((state) => state.reportStatus.isLoading);
  const isSelectedFilters = useSelector((state) => state.reportStatus.isSelectedFilters);
  const months = useSelector((state) => state.reportSummaryDictionaries.months);

  const dataSource = useMemo(() => groupByOrganization(tableData), [tableData]);

  const isKz = i18n.language === 'kz';

  const columns = useMemo(() => {
    const monthColumns = [...months]
      .sort((a, b) => a.id - b.id)
      .map((m) => ({
        title: (isKz && m.nameKk) || m.nameRu,
        dataIndex: ['statusByMonth', m.id],
        key: `month-${m.id}`,
        align: 'center',
        width: 80,
        render: (statusValue) => {
          const meta = STATUS_META[statusValue] || STATUS_META.NONE;
          return <div className={meta.className}>{t(meta.i18nKey)}</div>;
        },
      }));

    return [
      {
        title: t('reportStatus.numberShort'),
        key: 'index',
        align: 'center',
        width: 56,
        render: (_v, _r, index) => index + 1,
      },
      {
        title: t('reportStatus.organization'),
        key: 'organization',
        width: 280,
        render: (_v, record) =>
          (isKz && record.organizationNameKk) || record.organizationNameRu,
      },
      ...monthColumns,
    ];
  }, [months, t, isKz]);

  if (!isSelectedFilters) {
    return null;
  }

  return (
    <div className='container-table'>
      <Spin
        tip={t('intersections.loadingPleaseWait') + '...'}
        spinning={isLoading}
      >
        <AntdTable
          className='table-report-status'
          rowKey={(record) => record.organizationId}
          columns={columns}
          dataSource={dataSource}
          pagination={dataSource.length > 10}
          bordered
          scroll={{ x: 'max-content' }}
        />
      </Spin>
    </div>
  );
};
